import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useAlertActions, useLoadingActions } from "@/store";
import PasswordField from "../../../PasswordField";
import { doPasswordChange } from "../../../../firebase/auth";
import {
  FormContainer,
  AuthTitleBlock,
  TitleText,
  ChangePassFormWrapper,
  ButtonWrapper,
  SubmitButton,
  ErrorText,
} from "../../../AuthForm/AuthSteps/Auth.elements";

const ChangePasswordForm = ({ onSuccess }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm({ mode: "onSubmit", reValidateMode: "onSubmit" });

  const [currentPasswordError, setCurrentPasswordError] = useState("");

  const { showLoading, hideLoading } = useLoadingActions();
  const { hideAlert } = useAlertActions();

  useEffect(() => {
    if (!currentPasswordError) return;
    const sub = watch(() => setCurrentPasswordError(""));
    return () => sub.unsubscribe();
  }, [watch, currentPasswordError]);

  const currentPassword = (watch("currentPassword") || "").trim();
  const newPassword = (watch("newPassword") || "").trim();
  const confirmNewPassword = (watch("confirmNewPassword") || "").trim();

  const allFilled = !!currentPassword && !!newPassword && !!confirmNewPassword;

  const onSubmitInternal = async (data) => {
    try {
      showLoading();
      hideAlert();
      await doPasswordChange(data.currentPassword, data.newPassword);
      hideLoading();
      onSuccess?.();
    } catch (error) {
      hideLoading();
      setCurrentPasswordError("Current password is incorrect");
    }
  };

  return (
      <FormContainer>
        {currentPasswordError && <ErrorText>{currentPasswordError}</ErrorText>}

        <form onSubmit={handleSubmit(onSubmitInternal)}>
          <ChangePassFormWrapper>
            <PasswordField
                label="Current Password"
                fieldName="currentPassword"
                register={register}
                errors={errors}
                validation={{ required: "Current password is required" }}
            />

            <PasswordField
                label="New Password"
                fieldName="newPassword"
                register={register}
                errors={errors}
                validation={{
                  required: "New password is required",
                  minLength: {
                    value: 6,
                    message: "Password must be at least 6 characters long",
                  },
                }}
            />

            <PasswordField
                label="Confirm New Password"
                fieldName="confirmNewPassword"
                register={register}
                errors={errors}
                validation={{
                  required: "Please confirm your new password",
                  validate: (value) =>
                      value === watch("newPassword") || "Passwords do not match",
                }}
            />
          </ChangePassFormWrapper>

          <ButtonWrapper>
            <SubmitButton
                buttonState="auth"
                type="submit"
                disabled={!allFilled || Object.keys(errors).length > 0}
            >
              Change Password
            </SubmitButton>
          </ButtonWrapper>
        </form>
      </FormContainer>
  );
};

export default ChangePasswordForm;
